import { customertypeService } from "./contactservice/customertype.service";
import { customerstatusService } from "./contactservice/customerstatus.service";
import { paymenttermService } from "./paymentservice/paymentterm.service";
import { propertyService } from "./propertyservice/property.service";
import { projectfloorService } from "./projectservice/projectfloor.service";
import { projectgroupService } from "./projectservice/projectgroup.service";
import { propertytypeService } from "./propertyservice/propertytype.service";
import { propertystatusService } from "./propertyservice/propertystatus.service";
import { propertycancelationService } from "./propertyservice/propertycancelation.service";
import { propertyhandoverService } from "./propertyservice/propertyhandover.service";
import { propertylayouthandoverService } from "./propertyservice/propertypayoffhandover.service";
import { projectService } from "./projectservice/project.service";
import { commissiontypeService } from "./saleservice/commissiontype.service";
import { templateService } from "./saleservice/template.service";
import { settingService } from "./settingservice/setting.service";
import { sellerTypeService } from "./saleservice/sellertype.service";
import { roleService } from "./authservice/role.service";
import { accountService } from "./accountservice/account.service";
import { accountTypeService } from "./accountservice/accounttype.service";
import { itemtransactionstatusService } from "./inventoryservice/itemtransactionstatus.service";
import { itemtransactiontypeService } from "./inventoryservice/itemtransactiontype.service";
import { roomStatus } from "./managements/services/roomstatus.service";
import { incomeExpenseItemTypeService } from "./settingservice/incomeexpenseitemtype.service";

/* eslint-disable no-console */
export const servicehelpers = {
    getaymentTermData,
    getCurrencyData,
    getProjectData,
    getPropertyData,
    getCommissionTypeData,
    getCommissionTypeForData,
    getPayementTypeData,
    getTemplateData,
    getDiscountTypeData,
    getIDTypeData,
    getGenderData,
    getNatureData,
    getNationalityData,
    getCustomerTypeData,
    getCustomerStatusData,
    getTermData,
    getRoundingRuleData,
    getLoanTypeData,
    getPropertyTypeData,
    getPropertyStatusData,
    getPropertyCancelationStatusData,
    getPropertyHandoverStatusData,
    getPropertyLayoutHandoverStatusData,
    getFloorData,
    getGroupData,
    getPaymentTermTypeData,
    getCustomerData,
    getPaymentSchedule,
    getSellerTypeData,
    getRoleData,
    getAccountData,
    getAccountTypeData,
    getItemTransactionType,
    getItemTransactionStatus,
    getSupplierData,
    getRoomStatusData,
    getIncomeExpenseItemType,
    getResponsePeople
};

function getaymentTermData() {
    // if('paymentterm' in localStorage) {
    //     return Promise.resolve(JSON.parse(localStorage.paymentterm));
    // } else {
    //     return paymenttermService.getList()
    //         .then(response => {
    //             localStorage.paymentterm = JSON.stringify(response);
    //             return response;
    //         });
    // }


    if('paymentterm' in localStorage) {
        let paymentterm = JSON.parse(localStorage.paymentterm);
        // let data = paymentterm.data.filter((item) => item.for_sale == 0); 
        // paymentterm.data = data;

        return Promise.resolve(paymentterm);
    } else {
        return paymenttermService.getList()
            .then(response => {
                localStorage.paymentterm = JSON.stringify(response);

                let paymentterm = response;
                // let data = paymentterm.data.filter((item) => item.for_sale == 0);
                // paymentterm.data = data;

                return paymentterm;
            });
    }
}

function getCurrencyData() {
    if('currency' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.currency));
    } else {
        return settingService.getCurrencyList()
            .then(response => {
                localStorage.currency = JSON.stringify(response);
                return response;
            });
    }
}

function getDiscountTypeData() {
    if('discounttype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.discounttype));
    } else {
        return settingService.getDiscountTypeList()
            .then(response => {
                localStorage.discounttype = JSON.stringify(response);
                return response;
            });
    }
}

function getIDTypeData() {
    if('idtype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.idtype));
    } else {
        return settingService.getIDTypeList()
            .then(response => {
                localStorage.idtype = JSON.stringify(response);
                return response;
            });
    }
}

function getGenderData() {
    if('gender' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.gender));
    } else {
        return settingService.getGenderList()
            .then(response => {
                localStorage.gender = JSON.stringify(response);
                return response;
            });
    }
}



function getTermData() {
    if('term' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.term));
    } else {
        return settingService.getTermList()
            .then(response => {
                localStorage.term = JSON.stringify(response);
                return response;
            });
    }

}

function getPaymentTermTypeData() {
    if('paymenttermtype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.paymenttermtype));
    } else {
        return settingService.getPaymentTermTypeList()
            .then(response => {
                localStorage.paymenttermtype = JSON.stringify(response);
                return response;
            });
    }

}

function getRoundingRuleData() {
    if('roundingrule' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.roundingrule));
    } else {
        return settingService.getRoundingRuleList()
            .then(response => {
                localStorage.roundingrule = JSON.stringify(response);
                return response;
            });
    }
}

function getLoanTypeData() {
    if('loantype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.loantype));
    } else {
        return settingService.getLoanTypeList()
            .then(response => {
                console.log(response);
                localStorage.loantype = JSON.stringify(response);
                return response;
            });
    }
}

function getNationalityData() {
    if('nationality' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.nationality));
    } else {
        return settingService.getNationalityList()
            .then(response => {
                localStorage.nationality = JSON.stringify(response);
                return response;
            });
    }
}

function getCustomerTypeData() {
    if('customertype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.customertype));
    } else {
        return customertypeService.getList()
            .then(response => {
                localStorage.customertype = JSON.stringify(response);
                return response;
            });
    }
}

function getCustomerStatusData() {
    if('customerstatus' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.customerstatus));
    } else {
        return customerstatusService.getList()
            .then(response => {
                localStorage.customerstatus = JSON.stringify(response);
                return response;
            });
    }
}

function getCommissionTypeData() {
    if('commissiontype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.commissiontype));
    } else {
        return commissiontypeService.getList()
            .then(response => {
                localStorage.commissiontype = JSON.stringify(response);
                return response;
            });
    }
}

function getPayementTypeData() {
    if('paymenttype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.paymenttype));
    } else {
        return commissiontypeService.getPaymentType()
            .then(response => {
                localStorage.paymenttype = JSON.stringify(response);
                return response;
            });
    }
}

function getCommissionTypeForData() {
    if('commissiontypefor' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.commissiontypefor));
    } else {
        return commissiontypeService.getCommissionTypeFor()
            .then(response => {
                localStorage.commissiontypefor = JSON.stringify(response);
                return response;
            });
    }
}


function getProjectData() {
    if('project' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.project));
    } else {
        return projectService.getList()
            .then(response => {
                localStorage.project = JSON.stringify(response);
                return response;
            });
    }
}

function getPropertyTypeData() {
    if('propertytype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.propertytype));
    } else {
        return propertytypeService.getList()
            .then(response => {
                localStorage.propertytype = JSON.stringify(response);
                return response;
            });
    }
}



function getPropertyStatusData() {
    if('propertystatus' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.propertystatus));
    } else {
        return propertystatusService.getList()
            .then(response => {
                localStorage.propertystatus = JSON.stringify(response);
                return response;
            });
    }
}

function getPropertyCancelationStatusData() {
    if('propertycancelationstatus' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.propertycancelationstatus));
    } else {
        return propertycancelationService.getStatusList()
            .then(response => {
                localStorage.propertycancelationstatus = JSON.stringify(response);
                return response;
            });
    }
}

function getPropertyHandoverStatusData() {
    if('propertyhandoverstatus' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.propertyhandoverstatus));
    } else {
        return propertyhandoverService.getStatusList()
            .then(response => {
                localStorage.propertyhandoverstatus = JSON.stringify(response);
                return response;
            });
    }
}

function getPropertyLayoutHandoverStatusData() {
    if('propertylayouthandoverstatus' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.propertylayouthandoverstatus));
    } else {
        return propertylayouthandoverService.getStatusList()
            .then(response => {
                localStorage.propertylayouthandoverstatus = JSON.stringify(response);
                return response;
            });
    }
}

function getPropertyData(projectId = 0) {
    if('property' in localStorage) {
        let property = JSON.parse(localStorage.property);
        if(projectId != 0) {
            let data = property.data.filter((item) => item.project_id == projectId);
            property.data = data;
        }

        return Promise.resolve(property);
    } else {
        return propertyService.getList('?page=0')
            .then(response => {
                localStorage.property = JSON.stringify(response);
                let property = response;
                if(projectId != 0) {
                    let data = property.data.filter((item) => item.project_id == projectId);
                    property.data = data;
                }

                return property;
            });
    }

    // return propertyService.getList('?page=0')
    //         .then(response => {
    //             localStorage.property = JSON.stringify(response);
    //             let property = response;
    //             if(projectId != 0) {
    //                 let data = property.data.filter((item) => item.project_id == projectId);
    //                 property.data = data;
    //             }

    //             return property;
    //         });
}

function getFloorData(projectId = 0) {
    if('floor' in localStorage) {
        let floor = JSON.parse(localStorage.floor);
        if(projectId != 0) {
            let data = floor.data.filter((item) => item.project_id == projectId);
            floor.data = data;
        }

        return Promise.resolve(floor);
    } else {
        return projectfloorService.getList('?page=0')
            .then(response => {
                localStorage.floor = JSON.stringify(response);
                let floor = response;
                if(projectId != 0) {
                    let data = floor.data.filter((item) => item.project_id == projectId);
                    floor.data = data;
                }

                return floor;
            });
    }
}

function getGroupData(projectId = 0) {
    if('gruop' in localStorage) {
        let gruop = JSON.parse(localStorage.gruop);
        if(projectId != 0) {
            let data = gruop.data.filter((item) => item.project_id == projectId);
            gruop.data = data;
        }

        return Promise.resolve(gruop);
    } else {
        return projectgroupService.getList('?page=0')
            .then(response => {
                localStorage.gruop = JSON.stringify(response);
                let gruop = response;
                if(projectId != 0) {
                    let data = gruop.data.filter((item) => item.project_id == projectId);
                    gruop.data = data;
                }

                return gruop;
            });
    }
}

function getTemplateData(type = 0) {
    if('template' in localStorage) {
        let template = JSON.parse(localStorage.template);
        if(type != 0) {
            let data = template.data.filter((item) => item.contract_type_id == type);
            template.data = data;
        }
        return Promise.resolve(template);
    } else {
        return templateService.getList()
            .then(response => {
                localStorage.template = JSON.stringify(response);

                let template = response;
                if(type != 0) {
                    let data = template.data.filter((item) => item.contract_type_id == type);
                    template.data = data;
                }

                return template;
            });
    }
}

function getCustomerData() {
    if('customer' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.customer));
    } else {
        return customertypeService.getList('?page=0')
            .then(response => {
                localStorage.customer = JSON.stringify(response);
                return response;
            });
    }
}

function getPaymentSchedule(termId = 0) {
    
    if('paymentschedule' in localStorage) {
        // console.log(localStorage);
        let paymentschedule = JSON.parse(localStorage.paymentschedule);
        

        if(termId != 0) {

            let data = paymentschedule.data.filter((item) => item.payment_term_id === termId);
            paymentschedule.data = data;

            //console.log(paymentschedule.data);
        }

        return Promise.resolve(paymentschedule);
    } else {
        return paymenttermService.getDetailList()
            .then(response => {
                localStorage.paymentschedule = JSON.stringify(response);
                let paymentschedule = response;
                if(termId != 0) {
                    let data = paymentschedule.data.filter((item) => item.payment_term_id === termId);
                    paymentschedule.data = data;
                }

                return paymentschedule;
            });
    }
}

function getSellerTypeData() {
    if('sellertype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.sellertype));
    } else {
        return sellerTypeService.getList()
            .then(response => {
                localStorage.sellertype = JSON.stringify(response);
                return response;
            });
    }
}

function getRoleData() {
    if('role' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.role));
    } else {
        return roleService.getList()
            .then(response => {
                localStorage.role = JSON.stringify(response);
                return response;
            });
    }
}

function getAccountData(type = 0) {
    if('account' in localStorage) {
        let account = JSON.parse(localStorage.account);

        if(type != 0) {
            let data = account.data.filter((item) => item.account_type_id == type);
            account.data = data;
        }
        return Promise.resolve(account);
    } else {
        return accountService.getList('?page=0')
            .then(response => {
                localStorage.account = JSON.stringify(response);

                let account = response;
                if(type != 0) {
                    let data = account.data.filter((item) => item.account_type_id == type);
                    account.data = data;
                }

                return account;
            });
    }
}

function getAccountTypeData() {
    if('accounttype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.accounttype));
    } else {
        return accountTypeService.getList()
            .then(response => {
                localStorage.accounttype = JSON.stringify(response);
                return response;
            });
    }
}

function getItemTransactionType() {
    if('itemtransactiontype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.itemtransactiontype));
    } else {
        return itemtransactiontypeService.getList()
            .then(response => {
                localStorage.itemtransactiontype = JSON.stringify(response);
                return response;
            });
    }
}

function getItemTransactionStatus() {
    if('itemtransactionstatus' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.itemtransactionstatus));
    } else {
        return itemtransactionstatusService.getList()
            .then(response => {
                localStorage.itemtransactionstatus = JSON.stringify(response);
                return response;
            });
    }
}

function getNatureData() {
    if('nature' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.nature));
    } else {
        return settingService.getNatureList()
            .then(response => {
                localStorage.nature = JSON.stringify(response);
                return response;
            });
    }
}

function getSupplierData() {
    if('supplier' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.supplier));
    } else {
        return settingService.getSupplierList()
            .then(response => {
                localStorage.supplier = JSON.stringify(response);
                return response;
            });
    }
}

function getRoomStatusData() {
    // if('roomstatus' in localStorage) {
    //     return Promise.resolve(JSON.parse(localStorage.roomstatus));
    // } else {
        return roomStatus.getList()
            .then(response => {
                localStorage.roomstatus = JSON.stringify(response);
                return response;
            });
    // }
}

function getIncomeExpenseItemType() {
    if('incomeexpenseitemtype' in localStorage) {
        return Promise.resolve(JSON.parse(localStorage.roomstatus));
    } else {
        return incomeExpenseItemTypeService.getList()
            .then(response => {
                localStorage.roomstatus = JSON.stringify(response);
                return response;
            });
    }
}

function getResponsePeople() {
    return Promise.resolve(JSON.parse(localStorage.response_people));
}